export const isMockView = () => window.location.href.indexOf('mockviews') > -1;
